import React from "react"
import PropTypes from "prop-types"
import { InlineText } from "../../../Typography/Typography"

export const formatNumberAsGbp = (number, digits = 4) =>
  new Intl.NumberFormat("en-GB", {
    style: "currency",
    currency: "GBP",
    maximumSignificantDigits: digits,
  }).format(number)

const PricePerWeek = ({ price }) => (
  <InlineText large bold>
    {formatNumberAsGbp(price)}
    <InlineText> per week</InlineText>
  </InlineText>
)

PricePerWeek.propTypes = {
  price: PropTypes.number.isRequired,
}

export default PricePerWeek
